import { prop } from 'ramda';
import { send } from 'server';
import { getId } from 'device';
import { useCallback } from 'react';
import { useDeviceSelector } from 'js/store/hooks';

export const useRegisterPushApplication = () => {
    const id = getId();
    const browserName = useDeviceSelector(prop('browserName'));

    return useCallback(({ application, pushId, deviceId = id, deviceType = browserName }) => send({
        ID: 35613,
        description: 'Assign player personal device/browser request',
        responses: [35614, 35615],
        application,
        deviceId,
        pushId,
        deviceType
    }), [id, browserName]);
};
